import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
export function MembershipsPage() {
  return <div className="bg-brand-dark" data-id="element-786">
      <PageHero title="Memberships" subtitle="Exclusive access, priority reservations, and bespoke experiences." backgroundImage="https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=1920&q=80" data-id="element-787" />

      <section className="py-24 md:py-32 relative overflow-hidden" data-id="element-788">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-789"></div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-790">
          <div className="text-center mb-24" data-id="element-791">
            <motion.h2 className="text-4xl md:text-5xl font-serif text-white mb-6" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-792">
              Why Become a Member?
            </motion.h2>
            <motion.div className="w-16 h-1 bg-brand-gold mx-auto mb-10" initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} data-id="element-793" />
            <motion.p className="text-lg md:text-xl text-white/70 font-light max-w-3xl mx-auto leading-relaxed" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-794">
              Membership at JJ Group is more than just dining—it's an invitation
              into our inner circle. We offer two distinct tiers designed to
              elevate your personal lifestyle or enhance your corporate
              entertaining capabilities.
            </motion.p>
          </div>

          {/* Comparison Table */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-795">
            {/* Personal */}
            <motion.div className="bg-white/5 border border-white/10 p-10 backdrop-blur-sm relative group" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-796">
              <div className="absolute inset-0 border border-brand-gold opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-797"></div>
              <div className="relative z-10" data-id="element-798">
                <h3 className="text-3xl font-serif text-white mb-2" data-id="element-799">
                  Personal
                </h3>
                <p className="text-brand-gold text-sm uppercase tracking-widest mb-8" data-id="element-800">
                  The Jolu Circle
                </p>

                <ul className="space-y-4 mb-12" data-id="element-801">
                  {['Priority reservations across all concepts', 'Invitations to exclusive tasting events', 'Complimentary birthday dining experience', 'Dedicated concierge service'].map((perk, i) => <li key={i} className="flex items-start gap-3 text-white/80 font-light" data-id="element-802">
                      <Check size={18} className="text-brand-gold shrink-0 mt-1" data-id="element-803" />
                      {perk}
                    </li>)}
                </ul>

                <Link to="/memberships/personal" className="block text-center border border-brand-gold text-brand-gold py-4 text-sm uppercase tracking-widest hover:bg-brand-gold hover:text-brand-dark transition-colors" data-id="element-804">
                  Explore Personal
                </Link>
              </div>
            </motion.div>

            {/* Corporate */}
            <motion.div className="bg-white/5 border border-white/10 p-10 backdrop-blur-sm relative group" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-805">
              <div className="absolute inset-0 border border-brand-terracotta opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-806"></div>
              <div className="relative z-10" data-id="element-807">
                <h3 className="text-3xl font-serif text-white mb-2" data-id="element-808">
                  Corporate
                </h3>
                <p className="text-brand-terracotta text-sm uppercase tracking-widest mb-8" data-id="element-809">
                  Enterprise Partners
                </p>

                <ul className="space-y-4 mb-12" data-id="element-810">
                  {['Preferred rates on private dining spaces', 'Corporate catering priority scheduling', 'Customized corporate gifting programs', 'Flexible billing and account management'].map((perk, i) => <li key={i} className="flex items-start gap-3 text-white/80 font-light" data-id="element-811">
                      <Check size={18} className="text-brand-terracotta shrink-0 mt-1" data-id="element-812" />
                      {perk}
                    </li>)}
                </ul>

                <Link to="/memberships/corporate" className="block text-center border border-brand-terracotta text-brand-terracotta py-4 text-sm uppercase tracking-widest hover:bg-brand-terracotta hover:text-brand-dark transition-colors" data-id="element-813">
                  Explore Corporate
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}